import React from "react";
import './showJson.css';

export class ShowJson extends React.Component {
    render() {
        return (
            <div className="ShowJson">
                <button className="close-button" onClick={this.props.onClose}>Close</button>
                <pre>{JSON.stringify(JSON.parse(this.props.jsonData), null, 4)}</pre>
            </div>
        );
    }
}

export default ShowJson;
